import React from 'react';
import { EPresenceStatusApi, EStatus } from '@/shared/enums/presence.enum';
import { Badge, Button, Tooltip } from 'antd';
import { PresetStatusColorType } from 'antd/lib/_util/colors';

type AgentProps = {
  email: string;
  userName: string;
  presenceStatus: EPresenceStatusApi;
  isTransferring: boolean;
  onTransfer: (extensionId: string) => void;
};

const PresenceColorMapper = {
  [EPresenceStatusApi.AVAILABLE]: EStatus.SUCCESS,
  [EPresenceStatusApi.BUSY]: EStatus.ERROR,
  [EPresenceStatusApi.NOT_DISTURB]: EStatus.ERROR,
  [EPresenceStatusApi.ON_A_CALL]: EStatus.ERROR,
  [EPresenceStatusApi.BREAK]: EStatus.ERROR,
  [EPresenceStatusApi.WRAP_UP]: EStatus.ERROR,
  [EPresenceStatusApi.AWAY]: EStatus.WARNING,
  [EPresenceStatusApi.BERIGHTBACK]: EStatus.WARNING,
  [EPresenceStatusApi.OFFLINE]: EStatus.DEFAULT,
  [EPresenceStatusApi.VACATION]: EStatus.PROCESSING,
  [EPresenceStatusApi.UNKNOWN]: EStatus.DEFAULT,
};

export function Agent({
  email,
  userName,
  presenceStatus,
  isTransferring,
  onTransfer,
}: AgentProps) {
  return (
    <div className="chat-transfer-agent">
      <div className="chat-transfer-status">
        <Tooltip title={presenceStatus}>
          <Badge
            status={
              PresenceColorMapper[presenceStatus] as PresetStatusColorType
            }
          />
        </Tooltip>
        <div>{userName}</div>
      </div>

      <Button
        size="small"
        type="primary"
        data-testid="transfer"
        disabled={isTransferring}
        onClick={() => onTransfer(email)}
      >
        Transfer
      </Button>
    </div>
  );
}
